import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { CommonService } from './common.service';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { ErrorService } from './error.service';
import { HttpClient } from '@angular/common/http';

import { Driver, DriverPage, DriverList } from './../models/driver';

@Injectable()
export class DriverService {

  private url = CommonService.getEwdApiURL() + 'driver';

  constructor(
    private http: Http,
    private httpClient: HttpClient,
    private errorService: ErrorService
  ) { }

  private getUrlwith(id) {
      return this.url + '/' + id;
  }

  getDriver(id): Observable<Driver> {
      return this.http.get(this.getUrlwith(id))
          .map((response: Response) => {
              if (response.status === 204) {
                this.errorService.handleError(response);
              };
              return response.json();
          });
  }

  getDrivers(): Observable<Driver[]> {
    return this.http.get(this.url + '/list')
        .map((response: Response) => {
            if (response.status === 204) {
              this.errorService.handleError(response);
            };
            return response.json();
        });
  }

  searchDrivers(searchString): Observable<Driver[]> {
    return this.http.get(this.url + '/search?s=' + searchString)
        .map((response: Response) => {
            if (response.status === 204) {
              this.errorService.handleError(response);
            };
            return response.json();
        });
  }

  getDriversByCarrier(carrierId): Observable<Driver[]> {
      return this.http.get(this.url + '/Carrier/' + carrierId)
          .map((response: Response) => {
              if (response.status === 204) {
                this.errorService.handleError(response);
              };
              return response.json();
          });
  }

  getDriverByCarrierUser(userName: string): Observable<Driver[]> {
    return this.http.get(`${this.url}/CarrierUser/${userName}`)
        .map((response: Response) => {
            if (response.status === 204) {
              this.errorService.handleError(response);
            };
            return response.json();
        });
    }

  getDriverByUserName(userName: String): Observable<Driver> {
      return this.http.get(this.url + '/User/' + userName)
          .map((response: Response) => {
              if (response.status === 204) {
                this.errorService.handleError(response);
              };
              return response.json();
          });
  }

  getDriverOnly(): Observable<Driver> {
      return this.http.get(this.url + '/GetDriver')
          .map((response: Response) => {
              if (response.status === 204) {
                this.errorService.handleError(response);
              };
              return response.json();
          });
  }

  getByRecordKeeper(recordKeeperUserId: number): Observable<DriverList[]> {
    return this.http.get(this.url + '/RecordKeeper/' + recordKeeperUserId)
    .map((response: Response) => {
        if (response.status === 204) {
          this.errorService.handleError(response);
        };
        return response.json();
    });
  }

  getByRecordKeeperAssignedOnly(recordKeeperUserId: number): Observable<DriverList[]> {
    return this.http.get(this.url + '/RecordKeeperAssignedOnly/' + recordKeeperUserId)
    .map((response: Response) => {
        if (response.status === 204) {
          this.errorService.handleError(response);
        };
        return response.json();
    });
  }

  getTimeZoneIdFromState(state: string)
  {
    switch (state)
    {
      case "ACT":
        return 5;

      case "NSW":
        return 5;

      case "NT":
        return 10;

      case "QLD":
        return 6;

      case "SA":
        return 11;

      case "TAS":
        return 7;

      case "VIC":
        return 5;

      case "WA":
        return 19;
    }
  }

  addDriver(driver: Driver): Observable<number> {

      driver.TimeZoneId = this.getTimeZoneIdFromState(driver.BaseState);

      return this.http.post(this.url, driver)
        .map(
            (response: Response) => response.json()
            );
  }

  signUpDriver(driver: Driver, reCaptchaResponse: string): Observable<number> {

    driver.TimeZoneId = this.getTimeZoneIdFromState(driver.BaseState);

    const params: URLSearchParams = new URLSearchParams();
    if (reCaptchaResponse !== null)
    {
      params.set('reCaptchaResponse', reCaptchaResponse);
    }
    const queryString = params.toString();

    return this.http.post(CommonService.getEwdApiURL() + 'account/signupdriver?' + queryString, driver)
      .map(
          (response: Response) => response.json()
          );
  }

  updateDriver(id, driver: Driver): Observable<boolean> {

    driver.TimeZoneId = this.getTimeZoneIdFromState(driver.BaseState);

      return this.http.put(this.getUrlwith(id), driver)
          .map((response: Response) => {
              return true;
          });
  }

  deleteDriver(id): Observable<boolean> {
      return this.http.delete(this.getUrlwith(id))
          .map((response: Response) => {
              return true;
          });
  }

  enableDriver(id): Observable<boolean> {

    return this.http.get(this.url + '/enable/' + id)
      .map((response: Response) => {
        return true;
    });
  }
}


